import { render } from "./managementPanel.vue?vue&type=template&id=0543fdc0&scoped=true"
import script from "./managementPanel.vue?vue&type=script&lang=js"
export * from "./managementPanel.vue?vue&type=script&lang=js"

import "./managementPanel.vue?vue&type=style&index=0&id=0543fdc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0543fdc0"]])

export default __exports__